import type { Movement } from '../api/types'

export function MovementBadge({ movement }: { movement: Movement }) {
	if (movement === null) return <span className="muted">·</span>
	if (movement === 'new') return <span className="new">NEW</span>
	if (movement === 0) return <span className="muted">–</span>
	return movement > 0 ? (
		<span className="up" aria-label={`up ${movement}`}>
			▲{movement}
		</span>
	) : (
		<span className="down" aria-label={`down ${-movement}`}>
			▼{-movement}
		</span>
	)
}
